import { createStructuredSelector } from 'reselect';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import { select_cardBlockJS, select_card_data_ysc, select_isBoolean } from '../NetworkCards/selectors';
import { fetchTransactions, reportGenerate, fetchCardDataYsc } from './actions';
import { resetPopup } from '../HeaderContainer/actions';


const IndusIndRequestStatementPropTypes = {
  isLoadingStatus: bool.isRequired,
  onFetchCardDataYsc: func.isRequired,
  onReportGenerate: func.isRequired,
  onfetchTransactions: func.isRequired,
  onResetPopup: func.isRequired,
  match: shape({
    params: shape({
      id: string,
      type: string,
    }),
  }).isRequired,
  transactionsData: shape({
    transactions: arrayOf(
      shape({
        id: string,
      })),
    total_records: number,
  }).isRequired,
  CardDataYsc: shape({}).isRequired,
  isIndusindStatementData: shape({}).isRequired,
};


const IndusIndRequestStatementmapDispatchToProps = (dispatch) => ({
  onfetchTransactions: (payload, otherParams) => dispatch(fetchTransactions(payload, otherParams)),
  onFetchCardDataYsc: (payload) => dispatch(fetchCardDataYsc(payload)),
  onReportGenerate: (payload, otherParams) => dispatch(reportGenerate(payload, otherParams)),
  onResetPopup: (payload, actionType, alertType) => dispatch(resetPopup(payload, actionType, alertType)),
});

const IndusIndRequestStatementmapStateToProps = createStructuredSelector({
  CardDataYsc: select_card_data_ysc(),
  transactionsData: select_cardBlockJS('transactions'),
  isLoadingStatus: select_isBoolean('isLoading'),
  isIndusindStatementData: select_cardBlockJS('isIndusindStatement'),
});

export { IndusIndRequestStatementPropTypes, IndusIndRequestStatementmapStateToProps, IndusIndRequestStatementmapDispatchToProps };



// WEBPACK FOOTER //
// client/containers/IndusIndRequestStatement/IndusIndRequestStatementDatahandler.js